import { Controller } from "@hotwired/stimulus";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

export default class extends Controller {
  static targets = ["map", "value"];
  static values = {
    readOnly: { type: Boolean, default: false, },
    language: { type: String, default: "es" },
    position: { type: String, default: "topleft", },
    drawMarker: { type: Boolean, default: false, },
    drawCircleMarker: { type: Boolean, default: false, },
    drawPolyline: { type: Boolean, default: true, },
    drawRectangle: { type: Boolean, default: false, },
    drawPolygon: { type: Boolean, default: false, },
    drawCircle: { type: Boolean, default: false, },
    drawText: { type: Boolean, default: false, },
    cutPolygon: { type: Boolean, default: false, },
    rotateMode: { type: Boolean, default: false, },
    snappable: { type: Boolean, default: true, },
    exitModeOnEscape: { type: Boolean, default: true, },
    finishOnEnter: { type: Boolean, default: true, },
  }

  mapTargetConnected(mapTarget) {
    let value;

    this.map;

    try {
      value = JSON.parse(this.valueTarget.value);

      if (value?.features?.length > 0) {
        const geoJson = L.geoJSON(value, { snapIgnore: true });

        geoJson.addTo(this.map);

        this.map.fitBounds(geoJson.getBounds());
      }
    } catch (e) {
      console.error(e);
    }
  }

  mapTargetDisconnected(mapTarget) {
    this.map.remove();
  }

  get map () {
    if (!this._map) {
      this._map = L.map(this.mapTarget).setView([0,0], 5);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright" rel="noopener" target="_blank">OpenStreetMap contributors</a>'
      }).addTo(this._map);

      this._map.pm.setLang(this.languageValue);

      if (!this.readOnlyValue) {
        this._map.pm.addControls({
          position: this.positionValue,
          drawMarker: this.drawMarkerValue,
          drawCircleMarker: this.drawCircleMarkerValue,
          drawPolyline: this.drawPolylineValue,
          drawRectangle: this.drawRectangleValue,
          drawPolygon: this.drawPolygonValue,
          drawCircle: this.drawCircleValue,
          drawText: this.drawTextValue,
          cutPolygon: this.cutPolygonValue,
          rotateMode: this.rotateModeValue,
        });

        this._map.pm.setGlobalOptions({
          snappable: this.snappableValue,
          exitModeOnEscape: this.exitModeOnEscapeValue,
          finishOnEnter: this.finishOnEnterValue,
        });

        const changedEvent = this.changed.bind(this);

        this._map.on("pm:drawend", changedEvent);
        this._map.on("pm:create", (event) => {
          event.layer.on("pm:update", changedEvent);
          event.layer.on("pm:remove", changedEvent);
        });
      }
    }

    return this._map;
  }

  resize (event) {
    this.map.invalidateSize();
  }

  changed (event) {
    this.valueTarget.value = JSON.stringify(
      {
        type: 'FeatureCollection',
        features: L.PM.Utils.findLayers(this.map).map(x => x.toGeoJSON()),
      }
    );
  }
}
